/**
 * @desc 获取单条信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.LogisticsQuotationResponseDto>;
export function request(id: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/info/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
